import { Color } from "cesium";
import { ELongitudinalSlopeType, } from "../site/trench/types";
import { PathSlopeType } from "../site/mid-path/interface";
export function getDefaultEmbankmentFlatGroundSettings() {
    return {
        height: 5,
        moundSlope: 1.5,
        shelfWidth: 1.5,
        shelfSlope: 100,
        generateShelf: true,
        material: "#008000",
        transparency: 1,
    };
}
export function getDefaultCutFlatGroundSettings() {
    return {
        height: 7,
        moundSlope: 1,
        shelfWidth: 1.5,
        shelfSlope: 100,
        generateShelf: true,
        material: "#FFA500",
        transparency: 1,
    };
}
export function getFlatGroundCommonSettings() {
    return {
        interpolationPitch: 5,
        withSlope: true,
        surfaceColor: "#DDDDDD",
        transparency: 1.0,
    };
}
export function getDefaultFlatGroundSettings() {
    return {
        commonSettings: getFlatGroundCommonSettings(),
        cutSettings: getDefaultCutFlatGroundSettings(),
        embankmentSettings: getDefaultEmbankmentFlatGroundSettings(),
    };
}
export function getDefaultFlatGroundEdgeSettings() {
    return {
        width: 1,
        color: Color.BLUE,
        outlineColor: Color.BLUE,
        outlineWidth: 1,
        clampToGround: false,
        epsilonGapBetWeenMeshAndPolyline: 0.1,
    };
}
export function getDefaultControlLineSettings() {
    return {
        width: 1,
        color: Color.SKYBLUE.withAlpha(0.5),
        outlineColor: Color.RED,
        outlineWidth: 3,
        clampToGround: false,
        epsilonGapBetWeenMeshAndPolyline: 0.1,
    };
}
export function getDefaultCenterLineSettings() {
    return {
        width: 3,
        clampToGround: false,
        color: Color.BLACK,
    };
}
export function getDefaultPolylineSettings() {
    return {
        width: 9,
        color: Color.SKYBLUE.withAlpha(0.5),
        outlineColor: Color.BLUE,
        outlineWidth: 3,
        clampToGround: false,
        epsilonGapBetWeenMeshAndPolyline: 0.1,
    };
}
export function getDefaultCommonRoadSettings() {
    return {
        leftWidth: 2.5,
        rightWidth: 2.5,
        leftSlope: 50,
        rightSlope: 50,
        interpolationPitch: 5,
        surfaceColor: "#DDDDDD",
        segmentSettings: [],
    };
}
export function getDefaultEmbarkmentRoadSettings() {
    return {
        roadHeight: 5,
        moundSlope: 1.5,
        shelfWidth: 1.5,
        shelfSlope: 100,
        bLeftRightSettings: false,
        generateShelf: true,
        color: "#008000",
        transparency: 1,
        leftSlopeHeight: 5,
        leftMoundSlope: 1.5,
        leftShelfWidth: 1.5,
        leftShelfSlope: 100,
        rightSlopeHeight: 5,
        rightMoundSlope: 1.5,
        rightShelfWidth: 1.5,
        rightShelfSlope: 100,
        outline: true,
        outlineColor: Color.BLACK,
        controlLineSettings: getDefaultControlLineSettings(),
        centerLineSettings: getDefaultCenterLineSettings(),
        polyLineSettings: getDefaultPolylineSettings(),
    };
}
export function getDefaultCutRoadSettings() {
    return {
        roadHeight: 5,
        moundSlope: 1,
        shelfWidth: 1.5,
        shelfSlope: 100,
        bLeftRightSettings: false,
        generateShelf: true,
        color: "#FFA500",
        transparency: 1,
        leftSlopeHeight: 5,
        leftMoundSlope: 1,
        leftShelfWidth: 1.5,
        leftShelfSlope: 100,
        rightSlopeHeight: 5,
        rightMoundSlope: 1,
        rightShelfWidth: 1.5,
        rightShelfSlope: 100,
        outline: true,
        outlineColor: Color.BLACK,
        controlLineSettings: getDefaultControlLineSettings(),
        centerLineSettings: getDefaultCenterLineSettings(),
        polyLineSettings: getDefaultPolylineSettings(),
    };
}
// export function getDefaultRoadSettings(): IAllRoadSettings {
//     return {
//         commonSettings: getDefaultCommonRoadSettings(),
//         cutSettings: getDefaultCutRoadSettings(),
//         embarkmentSettings: getDefaultEmbarkmentRoadSettings(),
//     }
// }
export function getDefaultRoadSettings() {
    return {
        commonSetting: {
            path: {
                leftWidth: 2.5,
                rightWidth: 2.5,
                roadSlopeType: PathSlopeType.CROSS,
                interpolationPitch: 5,
                leftSlope: 50,
                rightSlope: 50,
                color: "#DDDDDD",
                transparency: 1,
                controlLineSettings: getDefaultControlLineSettings(),
                centerLineSettings: getDefaultCenterLineSettings(),
                polyLineSettings: getDefaultPolylineSettings(),
            },
            cutSetting: {
                generateShelf: true,
                left: {
                    moundSlope: 1,
                    slopeHeight: 5,
                    shelfSlope: 100,
                    shelfWidth: 1.5,
                },
                right: {
                    moundSlope: 1,
                    slopeHeight: 5,
                    shelfSlope: 100,
                    shelfWidth: 1.5,
                },
                color: "#FFA500",
                transparency: 1,
            },
            embarkmentSetting: {
                generateShelf: true,
                left: {
                    moundSlope: 1,
                    slopeHeight: 5,
                    shelfSlope: 100,
                    shelfWidth: 1.5,
                },
                right: {
                    moundSlope: 1,
                    slopeHeight: 5,
                    shelfSlope: 100,
                    shelfWidth: 1.5,
                },
                color: "#008000",
                transparency: 1,
            },
        },
        // segmentSettings: [],
    };
}
export function getDefaultSectionHighlightSetting() {
    return {
        color: Color.LIGHTBLUE.withAlpha(0.55),
        outlineColor: Color.LIGHTBLUE,
        outlineWidth: 1,
    };
}
export function getDefaultSectionMarkerColorSettings() {
    return {
        ipControlPointColor: Color.FUCHSIA,
        markerColor: Color.RED,
        selectedColor: Color.BLUE,
    };
}
export function getDefaultPointToPointPMISettings() {
    return {
        width: 3,
        color: Color.YELLOW,
        clampToGround: false,
        outlineColor: Color.YELLOW,
        outlineWidth: 0,
    };
}
// TRENCH
export function getDefaultCommonTenchSettings() {
    return {
        leftWidth: 2.5,
        rightWidth: 2.5,
        leftSlope: 50,
        rightSlope: 50,
        interpolationPitch: 5,
        surfaceColor: "#DDDDDD",
        segmentSettings: [],
    };
}
export function getDefaultEmbarkmentTrenchSettings() {
    return {
        trenchHeight: 5,
        moundSlope: 1.5,
        shelfWidth: 1.5,
        shelfSlope: 100,
        bLeftRightSettings: false,
        generateShelf: true,
        color: "#008000",
        transparency: 1,
        leftSlopeHeight: 5,
        leftMoundSlope: 1.5,
        leftShelfWidth: 1.5,
        leftShelfSlope: 100,
        rightSlopeHeight: 5,
        rightMoundSlope: 1.5,
        rightShelfWidth: 1.5,
        rightShelfSlope: 100,
        outline: true,
        outlineColor: Color.BLACK,
        controlLineSettings: getDefaultControlLineSettings(),
        polyLineSettings: getDefaultPolylineSettings(),
    };
}
export function getDefaultCutTrenchSettings() {
    return {
        trenchHeight: 5,
        moundSlope: 1,
        shelfWidth: 1.5,
        shelfSlope: 100,
        bLeftRightSettings: false,
        generateShelf: false,
        color: "#FFA500",
        transparency: 1,
        leftSlopeHeight: 5,
        leftMoundSlope: 1,
        leftShelfWidth: 1.5,
        leftShelfSlope: 100,
        rightSlopeHeight: 5,
        rightMoundSlope: 1,
        rightShelfWidth: 1.5,
        rightShelfSlope: 100,
        outline: true,
        outlineColor: Color.BLACK,
        controlLineSettings: getDefaultControlLineSettings(),
        polyLineSettings: getDefaultPolylineSettings(),
    };
}
// export function getDefaultRoadSettings(): IAllRoadSettings {
//     return {
//         commonSettings: getDefaultCommonRoadSettings(),
//         cutSettings: getDefaultCutRoadSettings(),
//         embarkmentSettings: getDefaultEmbarkmentRoadSettings(),
//     }
// }
export function getDefaultTrenchSettings() {
    return {
        commonSetting: {
            path: {
                leftWidth: 2.5,
                rightWidth: 2.5,
                trenchSlopeType: PathSlopeType.CROSS,
                specifiedElevation: 1.0,
                interpolationPitch: 5,
                leftSlope: 50,
                rightSlope: 50,
                color: "#964B00",
                transparency: 1,
                controlLineSettings: getDefaultControlLineSettings(),
                polyLineSettings: getDefaultPolylineSettings(),
                longitudinalSlope: {
                    slopeType: ELongitudinalSlopeType.DEFAULT,
                },
            },
            cutSetting: {
                generateShelf: true,
                left: {
                    moundSlope: 1,
                    slopeHeight: 5,
                    shelfSlope: 100,
                    shelfWidth: 1.5,
                },
                right: {
                    moundSlope: 1,
                    slopeHeight: 5,
                    shelfSlope: 100,
                    shelfWidth: 1.5,
                },
                color: "#FFA500",
                transparency: 1,
            },
        },
        // segmentSettings: [],
    };
}
export function getDefaultLineworkSettings() {
    return {
        outlineColor: Color.YELLOW,
        outlineWidth: 0,
        show: false,
        width: 5,
        color: Color.YELLOW,
    };
}
export function getDefaultLineWorkCrossSectionSettings() {
    return {
        width: 3,
        color: Color.BLUE,
        clampToGround: false,
        outlineColor: Color.BLUE,
        outlineWidth: 0,
    };
}
/**
 * HeightMap cell size for flatgrounds, trenches, roads.
 */
export const OBJECT_CELL_SIZE = 0.1;
//# sourceMappingURL=earthbrain-site-settings.js.map